import { render, staticRenderFns } from "./registerService.vue?vue&type=template&id=5e0d9633&scoped=true&"
import script from "./registerService.vue?vue&type=script&lang=js&"
export * from "./registerService.vue?vue&type=script&lang=js&"
import style0 from "./registerService.vue?vue&type=style&index=0&id=5e0d9633&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0d9633",
  null
  
)

export default component.exports